var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestoneCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.247 1.158L3.281 6.917 1.697 5.225c-.291-.275-.75-.292-1.083-.058a.764.764 0 00-.217 1.008l1.875 3.05c.184.283.5.458.859.458.341 0 .666-.175.85-.458.3-.392 6.025-7.217 6.025-7.217.75-.766-.159-1.441-.759-.858v.008z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/milestoneCheck.11a80414.svg";
export { SvgMilestoneCheck as ReactComponent };